import React, { useEffect, useState } from 'react';

import Header from '@components/customise/option/header';
import Accordion, {
  AccordionItemData,
  AccordionItemValue,
} from '@components/accordion/accordion';

import '@styles/customise/option.scss';
import { VehicleOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoption';
import { StepWizardChildProps } from 'interface';
import { VehicleOptionItem } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoptionitem';
import { useSelectedOptions } from '@hooks/useselectedoptions';
import { OptionType } from '../../../enums';

interface VehicleOptionProps {
  options: VehicleOption[];
  stepWizard: StepWizardChildProps;
  hashKey: string;
}

const Options: React.FC<VehicleOptionProps> = ({ stepWizard, options }) => {
  const [optionsLocal, setOptionsLocal] = useState<AccordionItemData[]>([]);
  const { unselectOption, selectOption, isOptionSelected } =
    useSelectedOptions();

  const setSelectedOptions = (optionId: number, title: string) => {
    if (isOptionSelected(optionId, title, OptionType.option)) {
      unselectOption(optionId);
    } else {
      selectOption(optionId);
    }
  };

  useEffect(() => {
    const accordionOptionsData: AccordionItemData[] = [];
    if (options) {
      options.map((item, index) => {
        const itemValueList: AccordionItemValue[] = item.items.map((option) => {
          const valueList: string[] = [
            `${option.monthlyCost} p/m`,
            option.price,
          ];

          const dependants = option.optionRules
            ? option.optionRules.map((dependant: VehicleOptionItem) => {
                return {
                  label: dependant.label,
                  value: [`${dependant.monthlyCost} p/m`, dependant.price],
                  checked: dependant.checked,
                  id: dependant.id,
                } as AccordionItemValue;
              })
            : null;

          return {
            label: option.label,
            value: valueList,
            checked: option.checked,
            id: option.id,
            dependants: dependants,
            description: option.description,
            disabled: option.disabled,
          } as AccordionItemValue;
        });

        accordionOptionsData.push({
          index: index,
          title: item.name,
          content: itemValueList,
        });
      });
    }

    setOptionsLocal(accordionOptionsData);
  }, [options]);

  return (
    <div className="customise-options__options">
      <Header
        currentStep={stepWizard.currentStep}
        totalSteps={stepWizard.totalSteps}
        title="Options"
      />
      <div className="customise-options__content">
        <Accordion
          type="selectable"
          data={optionsLocal}
          isSearchable={true}
          searchPlaceholder="Filter Options"
          setSelectedOptions={setSelectedOptions}
          className="customise-options__content-accordion"
        />
      </div>
    </div>
  );
};

export default Options;
